import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ScheduledReportsService {
    private serverUrl = 'https://' + window.location.host; // TODO Get url and version number from appsettings.
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/scheduledreport').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    createScheduledReport(data: any): Observable<any> {
        return this.http.post(`${this._url}`, data);
    }

    getScheduledByReport(reportId: string): Observable<any[]> {
        let params = new HttpParams().set('reportId', reportId);
        return this.http.get<any[]>(`${this._url}/all/report`, { params: params });
    }

    getExports(): Observable<any[]> {
        return this.http.get<any[]>(`${this._url}/all/exports`);
    }

    getScheduledByUser(): Observable<any[]> {
        return this.http.get<any[]>(`${this._url}/all`);
    }

    deleteSchedule(userScheduledReportKey: number): Observable<any> {
        let data = {
            userScheduledReportKey: userScheduledReportKey,
        };

        let params = new HttpParams().set(
            'userScheduledReportKey',
            userScheduledReportKey.toString()
        );

        return this.http.get<any>(`${this._url}/delete`, { params: params });
    }

    download(blobIdentifier: string): Observable<Blob> {
        let body = {
            blobIdentifier: blobIdentifier,
        };

        return this.http.post<Blob>(this._url + '/download/', body, {
            responseType: 'blob' as 'json',
        });
    }

    getOptions() {
        return {
            when: [
                { name: 'Monthly', value: 3 },
                { name: 'Weekly', value: 2 },
                { name: 'Daily', value: 1 },
            ],
            day: [
                { name: 'Sunday', value: 0 },
                { name: 'Monday', value: 1 },
                { name: 'Tuesday', value: 2 },
                { name: 'Wednesday', value: 3 },
                { name: 'Thursday', value: 4 },
                { name: 'Friday', value: 5 },
                { name: 'Saturday', value: 6 },
            ],
            monthly: [
                { name: 'First', value: 'first' },
                { name: 'Fifteenth', value: '15' },
                { name: 'Last', value: 'last' },
            ],
            hour: [
                { name: '12:00 AM', value: 0 },
                { name: '1:00 AM', value: 1 },
                { name: '2:00 AM', value: 2 },
                { name: '3:00 AM', value: 3 },
                { name: '4:00 AM', value: 4 },
                { name: '5:00 AM', value: 5 },
                { name: '6:00 AM', value: 6 },
                { name: '7:00 AM', value: 7 },
                { name: '8:00 AM', value: 8 },
                { name: '9:00 AM', value: 9 },
                { name: '10:00 AM', value: 10 },
                { name: '11:00 AM', value: 11 },
                { name: '12:00 PM', value: 12 },
                { name: '1:00 PM', value: 13 },
                { name: '2:00 PM', value: 14 },
                { name: '3:00 PM', value: 15 },
                { name: '4:00 PM', value: 16 },
                { name: '5:00 PM', value: 17 },
                { name: '6:00 PM', value: 18 },
                { name: '7:00 PM', value: 19 },
                { name: '8:00 PM', value: 20 },
                { name: '9:00 PM', value: 21 },
                { name: '10:00 PM', value: 22 },
                { name: '11:00 PM', value: 23 },
            ],
        };
    }
}
